import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BedomareClient } from '../clients/etjanster-common-api/bedomare.client';
import { Bedomare } from '../models/bedomare.model';
import { BedomareRepository } from '../repositories/bedomare.repository';
import { ClaimResult } from '../models/claim-result';

@Injectable({ providedIn: 'root' })
export class BedomareCommand {
  constructor(
    private bedomareClient: BedomareClient,
    private bedomareRepository: BedomareRepository,
  ) {}

  public addNyckelord(nyckelord: string) {
    return this.bedomareClient.addNyckelord(nyckelord);
  }

  public assignBedomare(secret: string): Observable<ClaimResult> {
    return this.bedomareClient.assignBedomare(secret);
  }

  public updateBedomare(bedomare: Bedomare) {
    return this.bedomareClient
      .updateBedomare(bedomare)
      .pipe(
        map((updatedBedomare) =>
          this.bedomareRepository.setBedomare(updatedBedomare),
        ),
      );
  }
}
